import { IDeviceLink } from "../../model/DeviceLink";
import { ActionsUnion, createAction } from "../definitions";
import { DeviceLinkActionTypes } from "./types";

export interface IDeviceLinkPayload {
    userId: string;
    deviceLinks: IIdDictionary<IDeviceLink>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DeviceLinkActions = {
    setDeviceLinks: (payload: IDeviceLinkPayload) => createAction(DeviceLinkActionTypes.SET_DEVICE_LINKS, payload),
    /**
     * @param payload userId for which deviceLinks should be removed.
     */
    clearDeviceLinks: (payload: string) => createAction(DeviceLinkActionTypes.CLEAR_DEVICE_LINKS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DeviceLinkActions = ActionsUnion<typeof DeviceLinkActions>;